// setear el top position del megaMenu dinamicamente basado en la altura del header
document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('shopify-section-header');
    const megaMenu = document.querySelector('.mega-menu');

    function setMegaMenuTopPosition() {
        const headerHeight = header.offsetHeight;
        megaMenu.style.top = `${headerHeight}px`;
    }
    setMegaMenuTopPosition();
    const resizeObserver = new ResizeObserver(() => {
        setMegaMenuTopPosition();
    });
    resizeObserver.observe(header);
});
